import { defineMessages } from 'react-intl';

const messages = defineMessages({
  clippedImage: {
    id: 'Clipped Image',
    defaultMessage: 'Clipped Image',
  },
  previewImage: {
    id: 'Image',
    defaultMessage: 'Image',
  },
});

export default messages;
